import utils from "./utils";
// import { flightRxjsSubject, RxjsParams } from "./rxjs";
//整理格式化请求参数
import requestParameter from './requestParameter';
export default class flightTickets {
    constructor() {
        this.ticketList = null;
        this.filterParams = null;
        this.store = null; // vuex
        this.freeFlight = {
            success: true,
            reload: 1,
            data: {
                flightInlandItemSearchList: []
            }
        };
    }
    //数据状态初始化
    clean(store) {
        //恢复默认设置H页面
        //设置自由组合数据  freeFlight: { success: true, data: { flightInlandItemSearchList: [] } }
        store.commit("freeFlight", this.freeFlight);
        //设置筛选数组
        store.commit("setFilter", []);
        //currentIndex: 1,  //当前第几程
        store.commit("setCurrentIndex", 1);
        //choseTickets: [], // 选中的机票
        store.commit("setChoseTicket", []);
    }

    cleanSecondTicketList(store) {
        store.commit("freeFlight", this.freeFlight); //清空已有的数据，防止数据重复
    }
    //计算默认选中航程的机票总价
    //seqNum:当前第几程
    defaultPrice(store, seqNum) {
        let rxjs_msg = store.getters.getRxjsMsg;
        let defaultPrice = rxjs_msg.parameter.defaultPrice;
        let price = defaultPrice[seqNum - 1];
        return price;
    }
    /**
     * @method 整理机票列表数据
     * @param tabName:first/second (推荐组合/自由组合)
     * @param retData:机票数据
     * @param defaultPrice 默认选中航程的机票总价
     * @param sort 排序规则
     * @param filter 筛选项
     * @param store vuex状态数据
     * @return 整理后的数据（数组）
     */
    getTickets(tabName, retData, defaultPrice, sort, filter = null, store = null) {
        // 没有机票数据返回
        // debugger;
        if (!retData) {
            return;
        }
        if (tabName == "first") { //推荐组合
            let flightList = retData.flightList;
            if (flightList) {
                flightList = this.sortFitst(sort, flightList);
            }
            return flightList;
        } else { //自由组合
            //自由组合机票数据retData格式
            // {
            //     success: true,
            //     data: {
            //       flightInlandItemSearchList: []
            //     }
            //   }
            let data = retData.data;
            if (!data) {
                return []
            }
            //自由组合航班信息列表筛选整理
            let flightInlandItemSearchList = this.filterSecond(data.flightInlandItemSearchList, filter);
            if (!flightInlandItemSearchList) {
                return [];
            }
            //是否需要验舱验价（推荐组合不需要验舱验价，自由组合需要验舱验价）
            let needCheck = store.getters.getRxjsMsg.parameter.needCheck;
            // //当前航班信息flightkey
            let curFlightNos = store.getters.getRxjsMsg.parameter.curFlightNos;
            // //当前第几程
            let index = store.getters.getCurrentIndex;
            // //轮询条件
            let flightInlandPollingCondition = data.flightInlandPollingCondition;
            //自由组合航班信息列表
            flightInlandItemSearchList.map((item, i) => {
                //航段信息
                let obj = item.inlandConnectionInfoList[0];
                // let ItemObj = 
                //轮询条件
                item.flightInlandPollingCondition = flightInlandPollingCondition;
                //departureCityName ：出发城市名称
                item.transferCity = (item.inlandConnectionInfoList.length > 1) ? item.inlandConnectionInfoList[1].departureCityName : "";
                //具体经停信息
                let stopPoints = item.inlandConnectionInfoList[0].stopPoints;
                let stopPointsArr = [];
                if (stopPoints && stopPoints.length > 0) {
                    stopPoints.map((item) => {
                        stopPointsArr.push(item.cityName)
                    })
                }
                // item.borderClass = "flight_info_wrap free_flight_info_wrap";
                // item.btnClass = "sixth";
                //是否被选中
                item.isSelectedTicket = 0;
                if (needCheck && curFlightNos[index - 1] == item.flightKey) {
                    // item.borderClass = "flight_info_wrap free_flight_info_wrap chosed_warp";
                    item.isSelectedTicket = 1;
                    // item.btnClass = "sixth six-checked"
                }
                //arrivalDate：抵达日期   arrivalTime：到达时间    departureDate：出发时间
                //到达时间
                obj.arrivedateAndTime = obj.arrivalDate + " " + obj.arrivalTime;
                //是否跨天了
                obj.addDay = (obj.arrivalDate != obj.departureDate) ? true : false;
                //所有具体经停信息汇总
                item.stopPointsStr = stopPointsArr.join(",");

                //往返总价差
                // item.diffprices = item.price - defaultPrice;
                //往返总价差前的正负符号布尔值
                item.isInt = (item.price - defaultPrice) >= 0 ? true : false;
                //往返总价差绝对值
                item.diffprice = Math.abs(item.price - defaultPrice) | 0;
                //总的航段
                item.flightLength = item.inlandConnectionInfoList.length;

            })
           
            let flightInlandItemSearchList2 = JSON.parse(JSON.stringify(flightInlandItemSearchList));
            if (sort.type != "default") {
                flightInlandItemSearchList = this.sortSecond(sort, flightInlandItemSearchList2);
            }else{
                flightInlandItemSearchList = flightInlandItemSearchList2;
            }
            return flightInlandItemSearchList;
        }
    }

    /**
     * @method 推荐组合的数据排序整理
     * @param sort:排序规则
     * @param data:机票数据
     * @return 整理后的数据（数组）
     */
    sortFitst(sort, data) {
        data.map((item) => {
            let flightListItem = item.flightList[0];
            item.arrivalTimesort = new Date(flightListItem.arriveDate + " " + flightListItem.arriveTime).getTime();
            item.departTimesort = new Date(flightListItem.flightDate + " " + flightListItem.departTime).getTime();
            item.priceAdult = item.diffPrice;
        })
        let sortKey = this.getSortKey(sort);
        if (sort.sort == "asc") {
            data.sort((a, b) => {
                let diff = a[sortKey] - b[sortKey];
                return diff;
            })
        } else {
            data.sort((a, b) => {
                let diff = b[sortKey] - a[sortKey];
                return diff;
            })
        }
        return data;
    }

    getSortKey(sort) {
        let sortKey = '';
        if (sort.type == "arrival" || sort.type == "depart") {
            sortKey = sort.type + "Timesort";
        } else {
            sortKey = sort.type;
        }
        return sortKey;
    }
    /**
     * @method 推荐组合的数据排序整理
     * @param sort:排序规则
     * @param data:机票数据
     * @return 整理后的数据（数组）
     */
    sortSecond(sort, data) {
        // debugger;
        let data2 = JSON.parse(JSON.stringify(data));
        if (data2.length > 0) {
            data2.map((item) => {
                let inlandConnectionInfoList = item.inlandConnectionInfoList[0]
                let arrivalTime = inlandConnectionInfoList.arrivalDate + " " + inlandConnectionInfoList.arrivalTime;
                item.arrivalTime = arrivalTime;
                item.priceAdult = item.adultPrice;
                item.departTimesort = new Date(item.departTime).getTime();
                item.arrivalTimesort = new Date(item.arrivalTime).getTime();
            })
            let sortKey = this.getSortKey(sort);
            // debugger;
            if (sort.sort == "asc") {
                data2.sort((a, b) => {
                    let diff = a[sortKey] - b[sortKey];
                    return diff;
                })
            } else {
                data2.sort((a, b) => {
                    let diff = b[sortKey] - a[sortKey];
                    return diff;
                })
            }
        }
        return data2;
    }
    /**
     * @method 自由组合的数据筛选整理
     * @param data:自由组合的机票数据
     * @param filter 筛选项
     * @return 整理后的数据（数组）
     */
    filterSecond(data, filter) {
        for (let key in filter) {
            let item = filter[key];
            let type = item.value;
            // debugger;
            switch (type) {
                //航空公司
                case 4:
                    data = this.fiterSecondAll(data, filter[0], "airlineCompany");
                    //起飞机场
                case 5:
                    data = this.fiterSecondAll(data, filter[1], "dportName");
                    //降落机场
                case 6:
                    data = this.fiterSecondAll(data, filter[2], "aportName");
                    //直飞/中转
                case 7:
                    data = this.fiterSecondAll(data, filter[3], "transferFlag");
            }
        }
        return data;
    }
    /**
     * @method 自由组合的数据筛选整理
     * @param data:自由组合的机票数据
     * @param itemFilter 筛选项
     * @param key airlineCompany/dportName/aportName/transferFlag
     * @return 整理后的数据（数组）
     */

    fiterSecondAll(data, itemFilter, key) {
        // debugger;
        let newArr = new Array();
        let isAll = true;
        if (data && data.length > 0 && itemFilter && itemFilter.options.length > 0) {
            itemFilter.options.map((item, i) => {
                if (item.checked) {
                    isAll = false;
                    data.map((item2, i) => {
                        let inlandConnectionInfoList = item2.inlandConnectionInfoList[0];
                        let compareVal = inlandConnectionInfoList[key]
                        //直飞/中转 特殊处理
                        if (key != "transferFlag") {
                            if (compareVal == item.optionTitle) {
                                newArr.push(item2);
                            }
                        } else {
                            if (!compareVal) {
                                newArr.push(item2);
                            }
                        }
                    })
                }
            })
        }
        // return null;
        return isAll ? data : newArr;
    }




    getSeatType(inlandDetailInfos, defaultPrice) {

        if (inlandDetailInfos.length <= 0) {
            return inlandDetailInfos
        }
        let seatType = {
            first: {
                "typeName": "",
                "price": 0,
                "baggageInfo": "",
                "dinner": "",
                "groupId": ""
            }, //头等舱
            business: {
                "typeName": "",
                "price": 0,
                "baggageInfo": "",
                "dinner": "",
                "groupId": ""
            }, //公务舱
            economy: {
                "typeName": "",
                "price": 0,
                "baggageInfo": "",
                "dinner": "",
                "groupId": ""
            }, //经济舱
        }

        inlandDetailInfos.map((item, i) => {
            let priceFlightCabinList = item.priceJourneyCabinList[0].priceFlightCabinList[0];
            let currentLowest = {};
            let key = seatType.first;
            if (priceFlightCabinList.seatTypeName == "经济舱") {
                currentLowest = seatType.economy;
            } else if (priceFlightCabinList.seatTypeName == "公务舱") {
                currentLowest = seatType.business;
            } else {
                currentLowest = seatType.first;
            }
            // debugger;
            if (currentLowest.price < item.adultPrice && currentLowest.price >= 0) {
                currentLowest.price = item.adultPrice;
                currentLowest.typeName = priceFlightCabinList.seatTypeName;
                currentLowest.baggageInfo = priceFlightCabinList.baggageInfo;
                currentLowest.dinner = priceFlightCabinList.mealName;
                currentLowest.groupId = item.groupId;
                currentLowest.diffprice = item.adultPrice - defaultPrice; //逻辑待补充
                currentLowest.priceShow = currentLowest.diffprice >= 0 ? "+" : "-"; //逻辑待补充
            }
        })
        // debugger;
        let ret = [];
        for (let key in seatType) {
            ret.push(seatType[key]);
        }

        return ret;
    }

    static getTab(ProductData) {
        let tabList = [];
        if (ProductData.data) {
            let flightTicketInfo = ProductData.data.pkgTicketBySeq[0].pkgTicketList[0].flightTicketInfo;
            tabList = flightTicketInfo;
        }
        return tabList;
    }

    setChoseTickets(choseItem, currentTab, currentIndex, store, item2 = null) {

        //下一程
        if (currentTab == "first") {
            let flightList = choseItem.inlandFlightItemInfoLists[0];
            let stopInformation = "";
            if (flightList.stopPoints && flightList.stopPoints.length > 0) {
                stopInformation = flightList.stopPoints[0].cityName;
            }

            let choseTickets = {
                departureCityName: flightList.departureCityName,
                destinationCityName: flightList.destinationCityName,
                index: utils.getNumber(currentIndex),
                numberIndex: currentIndex,
                airlineCompany: flightList.airlineCompany,
                flightNo: flightList.flightNo,
                departureAirportName: flightList.departureCityName,
                arrivalAirportName: flightList.destinationCityName,
                terminalArrival: flightList.terminalArrival,
                terminalDeparture: flightList.terminalDeparture,
                arrivalTime: flightList.arrivalTime,
                departureTime: flightList.departureTime,
                duration: flightList.duration,
                stopInformation: stopInformation,
                isAddDay: flightList.departureDate != flightList.arrivalDate,
                base: choseItem,
                choseItem: choseItem
                // sltPrice:item2
            }
            this.setChoseTicketIntoStore(store, choseTickets, currentIndex);
        } else { //自由组合
            let inlandConnectionInfoDtoArr = JSON.parse(JSON.stringify(choseItem.inlandConnectionInfoList));
            let inlandConnectionInfoDto = JSON.parse(JSON.stringify(inlandConnectionInfoDtoArr[0]));
            inlandConnectionInfoDtoArr.map(item => item.journeyType = choseItem.journeyType);
            let freeFlight = store.getters.getFreeFlight;
            item2.priceFlightCabinList[0].price = item2.price; //价格复制  总价保持不变  数组中price = null
            // inlandConnectionInfoDto.queryId = queryId;
            choseItem.vendorId = item2.vendorId ? item2.vendorId : 0;
            let choseTickets = {
                numberIndex: currentIndex,
                departureCityName: inlandConnectionInfoDto.departureCityName,
                destinationCityName: inlandConnectionInfoDto.destinationCityName,
                index: utils.getNumber(currentIndex),
                airlineCompany: inlandConnectionInfoDto.airlineCompany,
                flightNo: inlandConnectionInfoDto.flightNo,
                departureAirportName: inlandConnectionInfoDto.dportName,
                arrivalAirportName: inlandConnectionInfoDto.aportName,
                terminalArrival: inlandConnectionInfoDto.terminalArrival,
                terminalDeparture: inlandConnectionInfoDto.terminalDeparture,
                arrivalTime: inlandConnectionInfoDto.arrivalTime,
                departureTime: inlandConnectionInfoDto.departureTime,
                duration: inlandConnectionInfoDto.duration,
                stopInformation: inlandConnectionInfoDto.stopInformation,
                isAddDay: inlandConnectionInfoDto.arrivalDate != inlandConnectionInfoDto.departureDate,
                base: inlandConnectionInfoDto,
                sltPrice: item2,
                choseItem: choseItem
            }
            choseTickets.base.priceFlightCabinList = item2.priceFlightCabinList;
            choseTickets.base.inlandConnectionInfoLists = inlandConnectionInfoDtoArr;
            choseTickets.base.inlandFlightItemInfoLists = inlandConnectionInfoDtoArr;
            choseTickets.base.inlandTransferInfoList = choseItem.inlandTransferInfoList;
            choseTickets.base.journeyType = choseItem.journeyType;
            choseTickets.base.vendorId = choseItem.vendorId;


            // 返回总飞行时间
            if (choseItem.journeyType) {
                choseTickets.base.durationTime = parseInt(choseTickets.base.duration);
            } else if (choseTickets.base.transferFlag) {
                let durationTime = choseItem.inlandTransferInfoList && choseItem.inlandTransferInfoList.length && parseInt(choseItem.inlandTransferInfoList[0].transferTime) || 0;
                inlandConnectionInfoDtoArr.forEach(item => {
                    if (item.duration) {
                        durationTime += parseInt(item.duration);
                    }
                })
                choseTickets.base.durationTime = durationTime;
            } else {
                choseTickets.base.durationTime = choseItem.durationTime;
            }
            this.setChoseTicketIntoStore(store, choseTickets, currentIndex);
        }

    }

    setChoseTicketIntoStore(store, choseTicket, currentIndex) {
        let currentTickets = store.getters.getChoseTicket;
        let isExits = false;
        currentTickets.some((item, j) => { //替换重复
            if (j + 1 == currentIndex) {
                currentTickets[j] = choseTicket;
                isExits = true;
            }
        })
        if (currentTickets.length <= 0) {
            currentTickets.push(choseTicket);
            isExits = true;
        }
        if (!isExits) {
            currentTickets.push(choseTicket);
        }
        store.commit("setChoseTicket", currentTickets);
    }

    dropTickets(index, store) {
        let droIndex = index;
        // 团票 第一程删除Index 散客票setTicketIndex没用到，不用考虑setTicketIndex值
        if (index == 0) {
            store.commit("setTicketIndex", -1);
        }
        store.commit("setCurrentIndex", droIndex + 1);
        let showTicket = store.getters.getChoseTicket;
        showTicket = showTicket.slice(0, index);
        store.commit("setChoseTicket", showTicket);
        //请求数据
        this.nextTickets(store, droIndex + 1);
    }

    nextTickets(store, next) {
        let obj = new requestParameter(store);
        let tabName = store.getters.getTabName;
        let chosedTickets = store.getters.getChoseTicket;
        let flightKey = "";
        if (chosedTickets.length > 0) {
            chosedTickets.map((item) => {
                let inlandFlightItemInfoLists = item.base;
                let flightStr = '';
                if (item.transferFlag) {
                    let inlandTransferInfoList = item.inlandTransferInfoList;
                    let arr = [];
                    inlandTransferInfoList.map((item2) => {
                        arr.push(item2.flightNo);
                    })
                    flightStr = arr.join("-");
                } else {
                    flightStr = item.flightNo
                }
                flightKey += flightStr
            })

        }

        if (tabName == "second") {
            let parameter = obj.secondParameter(1, next, 0, flightKey);
            store.commit("setParameter3", parameter);
            store.dispatch("freeFlightList", parameter);
        }
    }

    getCanReplaceTicket(store) {
        return store.getters.getRxjsMsg.parameter.groupTickets.canReplaceTicket;
    }
}